import axiosClient from "config/axiosClient"
import { IResponseService, IResponseServiceCollection } from "interfaces/IResponseService"
import { AxiosResponse } from "axios"
import { IRequestService, IRequestServiceLogin } from "interfaces/IRequestService"
import { ILoginInformation } from "interfaces/IUser"
import configEnv from "config/configEnv"
import { ISource } from "interfaces/ISource"

const clientAxios = axiosClient("OSM")
const clientSxiosOIM = axiosClient("OIM")

export const authService = async (
  user: IRequestServiceLogin,
): Promise<AxiosResponse<IResponseService<ILoginInformation>>> => {
  const client = clientAxios.getClient()

  const url = `${configEnv.urlUser}`

  const response = await client.post<IResponseService<ILoginInformation>>(
    url,
    {
      ...user,
      options: {
        permission: true,
      },
    },
    {
      headers: { "Content-Type": "application/json" },
    },
  )

  return response
}

export const authOtpService = async (
  challengeId: string,
  code: string,
): Promise<AxiosResponse<IResponseService<ILoginInformation>>> => {
  const client = clientAxios.getClient()
  const url = `${configEnv.urlUser}/otp`
  const response = await client.post<IResponseService<ILoginInformation>>(
    url,
    { challengeId, code },
    { headers: { "Content-Type": "application/json" } }
  )
  return response
}

export const getTypologyBySources = async (
  token: string,
  requestBody: IRequestService,
): Promise<AxiosResponse<IResponseService<Array<ISource>>>> => {
  const client = clientSxiosOIM.getClient()

  clientSxiosOIM.setTokenAuth(token)

  const url = `${configEnv.urlSources}`

  const response = await client.post<IResponseService<Array<ISource>>>(url, requestBody, {
    headers: { "Content-Type": "application/json" },
  })

  return response
}

export const getTypologyBySourcesAll = async (token: string): Promise<Array<ISource>> => {
  const client = clientSxiosOIM.getClient()
  clientSxiosOIM.setTokenAuth(token)

  const url = `${configEnv.urlSourcesAllOIM}`

  const requestBody = {
    skipRecords: 0,
    maxRecords: 10000,
    project: ["id", "name", "custom"],
  }

  let response = await client.post<IResponseServiceCollection<ISource>>(url, requestBody, {
    headers: { "Content-Type": "application/json" },
  })

  return response.data.message.records
}
